define.alias("shared/components/shared/social/refresh-profile-list", "calendar/components/shared/social/refresh-profile-list");